import { PossibleActions } from './admin.interface';
export enum UserAction {
  NEW_USER = "newUser",
  EDIT_USER = "editUser",
  DELETE_USER = "deleteUser",
  INVITE_USER = "inviteUser",
}

export enum CodeRole {
  SUPERADMIN = "SUPERADMIN",
  ADMINISTRATION = "ADMINISTRATION",
  STORE_MANAGER = "STORE_MANAGER",
  STORE_VIEWER = "STORE_VIEWER",
  CUSTOMER = "CUSTOMER",
  EXTERNAL_TECHNICIAN = "EXTERNAL_TECHNICIAN",
  SUBCONTRACTOR = "SUBCONTRACTOR",
  SECURITY_REFERENT = "SECURITY_REFERENT",
}

export interface UserInfo {
  idUser?: number;
  username?: string;
  descRole?: string;
  name?: string;
  surname?: string;
  email?: string;
  idHeadquarter?: number;
  headquarterName?: string;
  codeRole?: string;
  enabled?: boolean;
  company?: number;
  goStockCompanies?: any[];
  possibleActions?: PossibleActions;
}

export interface CompanyWarehousesRequest {
  requests: CompanyWarehouseRequest[]
}

export interface CompanyWarehouseRequest {
  id: number;
  allowAll: boolean;
  warehouses: number[];
}

export interface Company {
  id: number;
  name: string;
  shortName: string;
  allowAll: boolean;
  warehouses: number[];
  companyWarehouses: Warehouse[];
}

export interface Warehouse {
  id: number;
  code: string;
  name: string;
  description: string;
}

